/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import ISSUE_REPORT_TEMPLATES from 'SharedDir/backend/endpoints/issue-report-templates';
import { NIssueReport } from 'SharedDir/declarations/issue-report-templates';
import { ReportTaskBare } from 'SharedDir/declarations/report-tasks';

export default class IssueReportTemplatesApiClass {
  async getColumns(serviceId: number): Promise<NIssueReport.ColumnsOut> {
    const { data }: AxiosResponse<NIssueReport.ColumnsOut> = await http({
      ...ISSUE_REPORT_TEMPLATES.COLUMNS(serviceId),
    });
    return data;
  }

  /**
   * Ставит фон `sif-issues`. Ответ — задача, не blob файла.
   * Старые синхронные Excel: IssueApi.getReportForAll / getReportForSpecific.
   */
  async generate(
    serviceId: number,
    payload: NIssueReport.GeneratePayload
  ): Promise<ReportTaskBare> {
    const { data }: AxiosResponse<ReportTaskBare> = await http({
      ...ISSUE_REPORT_TEMPLATES.GENERATE(serviceId),
      data: payload,
    });
    return data;
  }
}
